module.exports = __webpack_public_path__ + "static/media/N14.44b08691.jpg";